module.exports = __webpack_public_path__ + "static/media/pdf.ef815cb7.png";